import { type Bonus, type Entity, bonus } from '../entities';
import { buttonClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { mergeWithTrackingContextValue } from './utils/mergeWithTrackingContextValue';

export const promotionAdded = (context: TrackingContextValue, bonusDetail: Bonus) => {
  const entities: Entity[] = [bonus(bonusDetail)];
  context = mergeWithTrackingContextValue(context, entities);

  GAEvent({ action: 'Add Promotion' }, context);
  buttonClick({ buttonName: 'Add Promotion' }, context);
};
